angular.module("app").provider('runtimeStates', function runtimeStates($stateProvider) {
    this.$get = function() {
        return {
            addState: function(name, state) {
                $stateProvider.state(name, state);
            },
            getStates: function () {
                return $stateProvider
            }
        }
    }
});